import React,{useState} from "react";
import style from "../../../styles/mystyle.module.css";
import { useTranslation } from "next-i18next";
import * as config from "../../../next.config.js";
import Link from "next/link";
import { constants } from "../../../constants";
// import Checkbox from "@mui/material/Checkbox";
// import { styled } from "@mui/system"
import getOffers from "../../helpers/offers";
import { useRouter } from "next/router";
import { useCart } from "../../../context/cart/use-cart";
import { getCookieValue } from "../../helpers/helpers";
// import OtherUnitsPrice from "./OtherUnitsPrice"
import OtherUnitsPrice from '../Product/OtherUnitsPrice'
import QuantityDialog from "../Dialogs/QuantityDialog"
import {CustomeCheckbox} from "./DetailsDiet.style"
import AddIcon from "@mui/icons-material/Add"
// const CustomeCheckbox = styled(Checkbox)(() => ({
//   "&.MuiCheckbox-root": {
//     padding: "16px"
//   }
// }));

function MealsCard({currency,...props}) {
  const { t } = useTranslation("common");
  const { addItem, removeItem, isInCart, getItem} = useCart();
  const handleAddButton = (e, data) => {
    addItem(data);
  };
  const handleRemoveButton = data => {
    removeItem(data);
  };
  const handleMinus = (e, data) => {
    handleRemoveButton(data);
  };
  const router = useRouter();
  let product;
  let Offerprice;
  let entityId
  let productOffer
  let procurrency
  let price
  let getExchangeCurrency=null
  let unit
  if (props.product) {
    getExchangeCurrency = currency.exchangeCurrencyRes && currency.exchangeCurrencyRes.filter(ele => ele.from == props.product.productUnitPrice[0].currency[0].id && ele.to == currency.currency)
  
    if(getExchangeCurrency&&getExchangeCurrency.length>0){
      getExchangeCurrency=getExchangeCurrency[0].exchangedAmount
    }
    else{
      getExchangeCurrency=currency.exchangeCurrencyRes.length>0?currency.exchangeCurrencyRes&&currency.exchangeCurrencyRes.filter(ele=>ele.from==props.product.productUnitPrice[0].currency[0].id )[0].exchangedAmount:1
    }
    procurrency = currency.currenciesLst.filter(ele => ele.id ==currency.currency).length>0&&currency.currenciesLst.filter(ele => ele.id ==currency.currency)[0].transCurrency.filter(ele => ele.language.code == router.locale)[0].currencySymbol
    if(props.product.productUnitPrice &&
      props.product.productUnitPrice.length > 0 &&
      props.product.productUnitPrice[0].displayPrice == true
      ){
        price= props.product.productUnitPrice[0].price
      }
    product = props.product;
 
    if (product.productUnitPrice.length && product.productUnitPrice.filter(ele=>ele.defaultPrice)[0].productOffer &&product.productUnitPrice[0].productOffer.length>0) {
      productOffer =  product.productUnitPrice.filter(ele=>ele.defaultPrice)[0].productOffer &&product.productUnitPrice[0].productOffer

      if (productOffer.length > 0) {
        Offerprice = getOffers(
          productOffer[0].fixedPrecentage,
          product.productUnitPrice.filter(ele=>ele.defaultPrice)[0].price,
          productOffer[0].fixedAmount
        );
     
      }
    
    }
    if (product.productUnitPrice &&  product.productUnitPrice.filter(ele=>ele.defaultPrice).length > 0) {
      unit=props.product.productUnitPrice[0].unit &&props.product.productUnitPrice[0].unit.length >0 ? props.product.productUnitPrice[0].unit &&props.product.productUnitPrice[0].unit.filter(i=>i.language.code==router.locale).length>0? props.product.productUnitPrice[0].unit.filter(i=>i.language.code==router.locale)[0].name : props.product.productUnitPrice[0].unit.name :""
       entityId =  product.productUnitPrice.filter(ele=>ele.defaultPrice)[0].entityDetailsId
     }
     else {
       entityId = props.entityId[0]
     }
  }
  const handleClose = () => {
    setOpenDailog(false);
  };
  const [OpenDailog,setOpenDailog]=useState(false)
  const [DataQuantityDialog,setDataQuantityDialog]=useState({open:false,entityDetailsId:null,productUnitPriceId:null,productId:null,quantity:null})
  const [otherPricesDialog,setOtherPricesDialog]=useState({data:null,open:false})
  return (
    <div>
      {/* {console.log("props=====>",props.image)} */}
    {DataQuantityDialog.open?
        <QuantityDialog open={DataQuantityDialog.open}
        productId={DataQuantityDialog.productId}
        productUnitPriceId={DataQuantityDialog.productUnitPriceId}
        entityDetailsId={DataQuantityDialog.entityDetailsId}
        quantity={DataQuantityDialog.quantity}
                btnOk={() => {
                
                  setDataQuantityDialog({
                    open: false
                }) 
                }} 
                btnCancel={() => {
                
                  setDataQuantityDialog({
                    open: false
                })   
                }}
              />:""}
          {OpenDailog?
      <OtherUnitsPrice data={product}  onClose={handleClose} productUnitPriceList={product.OtherUnitsPrice} open={OpenDailog} currency={currency}/>:""}
      <div className={style.allcard3}>
        <div className={style.stylesResturantOpen}>
          {props.showFavortie == true ?
            <>
              <div className={style.markandheartdetails}>
                <img
                  className={style.markdetails}
                  src={`${config.basePath}/assest/Myfav.svg`}
                  alt={"hakeem platform"}
                ></img>

                <CustomeCheckbox
                  icon={
                    <img
                      className={style.StarBorderDiet + " " + style.heartdetails}
                      src={`${config.basePath}/assest/OutlineStar.svg`}
                      alt={"hakeem platform"}
                    ></img>
                  }
                  onClick={(e) => {
                    if (e.target.checked == true) {
                      addItem({
                        type: "products",
                        entityId:  product.productUnitPrice.filter(ele=>ele.defaultPrice)[0].id,
                        isFavoriate: true,
                        quantity: 0,
                        productUnitPrice: null,
                        entityDetailsId: entityId,
                        userCountry: getCookieValue("userCountry")
                      })
                    } else if (e.target.checked == false) {
                      removeItem({
                        type: "products",
                        entityId:  product.productUnitPrice.filter(ele=>ele.defaultPrice)[0].id,
                        isFavoriate: false,
                        quantity: 0,
                        productUnitPrice: null,
                        entityDetailsId: entityId,
                        userCountry: getCookieValue("userCountry")
                      })
                    }
                  }}
                  checkedIcon={
                    <img
                      className={style.StarDiet + " " + style.heartdetails}
                      src={`${config.basePath}/assest/Fullstar.svg`}
                      alt={"hakeem platform"}
                    ></img>
                  }
                  checked={getItem(product.productUnitPrice[0].id, null, entityId, getCookieValue("userCountry")) != null && getItem( product.productUnitPrice.filter(ele=>ele.defaultPrice)[0].id, null, entityId, getCookieValue("userCountry")).isFavoriate == true}
                  className={style.heart}
                />

              </div>
            </>
            : ""}
          <div className={style.cardDiet + " " + style.heightdietdetails}>
            <div className={style.profileMedical}>
              <div className={style.profileandtextcardfood}>
                <div className={style.profile1}>

                  <Link
                    href={"/products/" + (product.slug && product.slug.length > 0 ? product.slug[0].url + "/" +  product.productUnitPrice.filter(ele=>ele.defaultPrice)[0].id : product.id + "/" +  product.productUnitPrice.filter(ele=>ele.defaultPrice)[0].id)}
                    className={style.AtagIcon}
                  >
                    {" "}
                    <div>

                      <img
                        className={style.cardImage}
                        alt={"hakeem platform"}
                        src={
                          props.image&&props.image?props.image.image:`${config.basePath}/assest/logo.svg`
                          // product.productImages.length > 0 && product.productImages[0].image != "" && product.productImages[0].image != null ?
                          //   product.productImages[0].image
                          //   : `${config.basePath}/assest/logo.svg`

                        }
                      ></img>
                    </div>{" "}
                  </Link>
                </div>
                <div className={style.profile2}>
                  <Link
                    className={style.AtagIcon + " " + style.hoverLink}
                    href={"/products/" + (product.slug && product.slug.length > 0 ? product.slug[0].url + "/" +  product.productUnitPrice.filter(ele=>ele.defaultPrice)[0].id : product.id + "/" +  product.productUnitPrice.filter(ele=>ele.defaultPrice)[0].id)}

                  >

                    <p
                      className={
                        style.textaboutresturant1 + " " + style.marginbottom
                      }
                    >
                      {product.transProduct &&
                        product.transProduct.length > 0 &&
                        product.transProduct.filter(
                          i => i.language && i.language.code == router.locale
                        ).length > 0
                        ? product.transProduct &&
                        product.transProduct.filter(
                          i => i.language && i.language.code == router.locale
                        )[0].name
                        : product.transProduct[0].name}
                           {"  "} {unit !=null && unit!==" "? "(" + unit +")":""}
                    </p>

                  </Link>
                  <div className={style.Twotextprice}>
                    {props.product.productUnitPrice &&
      props.product.productUnitPrice.length > 0 &&
      props.product.productUnitPrice[0].displayPrice == true?Offerprice != null ? (
                      <>
                        <p className={style.textaboutdoctor2}>
                          {(Offerprice*getExchangeCurrency).toLocaleString('en-US', { minimumFractionDigits: 2 })}{" "}
                          {procurrency}
                        </p>
                        {product.productUnitPrice[0].price == Offerprice ? "" : <p
                          className={
                            style.textaboutdoctor2 + " " + style.ColorText
                          }
                        >
                          <del>
                            {(price*getExchangeCurrency).toLocaleString('en-US', { minimumFractionDigits: 2 })
                             }{" "}
                          </del>
                          <span>
                            {procurrency}
                          </span>
                        </p>}
                      </>
                    ) : (
                        <p className={style.textaboutdoctor2}>
                          {(price*getExchangeCurrency).toLocaleString('en-US', { minimumFractionDigits: 2 })}{" "}
                          {procurrency}{" "}
                        </p>
                      ):t("priceHiddin")}
                  </div>
                </div>
              </div>
            </div>
            <div className={style.profileMedical}>
              <div className={style.StarandDistance}>
                      {/* {console.log("product=========>",product)} */}
              {otherPricesDialog.open?
      <OtherUnitsPrice data={otherPricesDialog.data}  onClose={()=>setOtherPricesDialog({...otherPricesDialog,open:false})} productUnitPriceList={[]} open={otherPricesDialog.open} currency={currency}/>:""}
                <div>
                  {(()=>{
                      if(product.productUnitPrice[0].ProductUnitPriceFeatures&&product.productUnitPrice[0].ProductUnitPriceFeatures.length>0&&product.OtherUnitsPrice &&product.OtherUnitsPrice.length==0){
                                    
                        return  <button     className={style.btnAdd+" "+     style.borderradiusTop + " " +style.Add}
                        onClick={() =>{
                          setOtherPricesDialog({...otherPricesDialog,open:true,data:{...product,productUnitPrice:product.productUnitPrice}})
                          
                        }}
                          
                          >   { <><AddIcon/> {t("showOptions")}</> } </button>
                
                      }
                      else if(product.OtherUnitsPrice&&product.OtherUnitsPrice.length>0){
                        return <button className={style.btnAdd+" "+     style.borderradiusTop + " " +style.Add}
                        onClick={() =>{
                         router.push(`/${constants.productUrl}/${product.slug.length > 0 && product.slug.filter(ele => ele.language.code == locale).length > 0 ? product.slug.filter(ele => ele.language.code == locale)[0].url : product.id}/${product.productUnitPrice &&  product.productUnitPrice.filter(ele=>ele.defaultPrice)[0].id}/other-prices`)
                        }}
                          >{ <><AddIcon/> {t("showOptions")}</> } </button>
  
                      }
                      else{
                        return <div

                        className={
                          style.borderradiusTop + " " +
                          (isInCart(product.id, "products",  product.productUnitPrice.filter(ele=>ele.defaultPrice)[0].id, entityId, getCookieValue("userCountry"))
                         && !(product.OtherUnitsPrice &&product.OtherUnitsPrice.length>0)? style.ClickAdd
                            : style.Add)
                        }
                        style={{ padding: 0 }}>{
                          isInCart(product.id, "products",  product.productUnitPrice.filter(ele=>ele.defaultPrice)[0].id, entityId, getCookieValue("userCountry")) &&!(product.OtherUnitsPrice &&product.OtherUnitsPrice.length>0) ? (
                          <div className={style.DivCount} style={{ borderBottomLeftRadious: '12px' }} >
    
                            <button
                              className={style.Count}
                              style={{ padding: 5 }}
                              onClick={e =>
                                handleAddButton(e, {
                                  type: "products",
                                  entityId: product.id,
                                  isFavoriate: false,
                                  quantity: 1,
                                  productUnitPrice:  product.productUnitPrice.filter(ele=>ele.defaultPrice)[0].id,
                                  entityDetailsId: entityId,
                                  userCountry: getCookieValue("userCountry")
                                })
                              }
                            >
                              {t("Plus")}
                            </button>
    
                            <div>
                            <button     className={style.Count + " " + style.raduis} onClick={e=>{setDataQuantityDialog({productId:product.id,productUnitPriceId: product.productUnitPrice.filter(ele=>ele.defaultPrice)[0].id,entityDetailsId:entityId,open:true,quantity:getItem(product.id,  product.productUnitPrice.filter(ele=>ele.defaultPrice)[0].id, entityId, getCookieValue("userCountry")) != null ? getItem(product.id,  product.productUnitPrice.filter(ele=>ele.defaultPrice)[0].id, entityId, getCookieValue("userCountry")).quantity:null})}}>
                              {getItem(product.id,  product.productUnitPrice.filter(ele=>ele.defaultPrice)[0].id, entityId, getCookieValue("userCountry")) != null ? getItem(product.id,  product.productUnitPrice.filter(ele=>ele.defaultPrice)[0].id, entityId, getCookieValue("userCountry")).quantity : ""}
                              </button>
    
                            </div>
                            <button
                              className={style.Count + " " + style.raduis}
                              onClick={e =>
                                handleMinus(e, {
                                  type: "products",
                                  entityId: product.id,
                                  isFavoriate: false,
                                  quantity: 1,
                                  productUnitPrice:  product.productUnitPrice.filter(ele=>ele.defaultPrice)[0].id,
                                  entityDetailsId: entityId,
                                  userCountry: getCookieValue("userCountry")
    
                                })
                              }
                            >
                              {t("Minus")}
                            </button>
                          </div>
                        ) : (
                          <button
                          className={style.btnAdd + " " + style.textaboutdoctor3 }
                          style={{ width: "100%" }}
                          onClick={e =>{
                            if( product.OtherUnitsPrice &&product.OtherUnitsPrice.length>0){
                             setOpenDailog(true)
                            }else{
                            handleAddButton(e, {
                              type: "products",
                              entityId: product.id,
                              isFavoriate: false,
                              quantity: 1,
                              productUnitPrice:  product.productUnitPrice.filter(ele=>ele.defaultPrice)[0].id,
                              entityDetailsId: entityId,
                              userCountry: getCookieValue("userCountry")
                            })
                          }
                        }
                          }
                        >
                          {product.OtherUnitsPrice &&product.OtherUnitsPrice.length>0?t("showOptions"):t("add")}
                        </button>
                          )
                      }</div>}
                    
                  })()}
                  
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MealsCard;
